@custom-media --mobile (max-width: 768px);

.center {
  text-align: center;
}

.right {
  text-align: right;
}

.hidden {
  display: none;
}

.hiddenMobile {
  @media (--mobile) {
    display: none;
  }
}

.centerVertical {
  margin-top: auto;
  margin-bottom: auto;
}
